import Button from '../../../../components/Button/Button';
import Menu from '../../../../components/Menu/Menu';
import './Races.scss'
import api from '../../../../js/api.js';
import { useEffect, useState } from 'react';
import Select from '../../../../components/Select/Select.jsx';
import { Link, useLocation } from 'react-router-dom';

export default function Races() {

    const [data, setData] = useState(null);
    const [selected_cars, setSelectedCars] = useState([]);
    const [raceDistance, setRaceDistance] = useState(0);

    useEffect(() => {
        const cached_data = localStorage.getItem('vehicles');
        if (cached_data)
            setData(JSON.parse(cached_data));
        else {
            const fetch_ = async () => {
                try {
                    const response = await api.get(`/vehicles`);
                    localStorage.setItem('vehicles', JSON.stringify(response));
                    setData(response);
                } catch (error) {
                    console.error(error);
                    setData({ "Error fetching data": "Error fetching data" });
                }
            }
            fetch_();
        }
    }, []);

    const handle_car_selection = (car) => {
        if (selected_cars.includes(car)) {
            return;
        }
        setSelectedCars([...selected_cars, car]);
    };

    const start_race = () => {
        console.log('start race!')
    }
    const reset = () => {
        setSelectedCars([]);
    }
    const location = useLocation();
    const basePath = location.pathname.split('/').slice(0, -1).join('/') + '/';


    class Car {
        constructor(name, data) {
            // console.log(data)
            this.name = name;
            this.max_speed = Number(data['performance']['top-speed'].split(' ')[0]); // km/h
            this.acceleration = Number(data['performance']['0-100'].split(' ')[0]); // secs
            this.battery = Number(data['battery']['capacity'].split(' ')[0]); // kWh
        }
    }

    return (
        <div id="races">
            <div className="centered-container">
                <h1 className='title'>Bev Races Simulator</h1>

                <h3>Options</h3>
                <div className='options-container'>
                    <span>Race distance: <input type='text' className='options-input'   ge={(e) => { setRaceDistance(e.target.value); }} /> Km</span>
                </div>

                <h3>Selected cars:</h3>
                <ul id='selected-cars-list'>
                    {selected_cars.map((car, index) => (
                        <li key={index}>
                            <Link to={`${basePath}database/${car}`} className='car-link'>
                                {car}
                            </Link>
                        </li>
                    ))}
                    {data ? (
                        <Select options={data} onChange={handle_car_selection} />
                    ) : (
                        <p>Searching cars...</p>
                    )}
                </ul>

                <div className='buttons-container'>
                    <Button text="Start" onClick={(e) => {
                        start_race();
                    }} />

                    <Button text="Reset" onClick={(e) => {
                        reset();
                        console.log(raceDistance)
                    }} />
                </div>



                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' }
                ]} />
                <i>
                    "Page in progress, original: <a href='https://ratonera.net/misc/evcars/races'>www.ratonera.net/misc/evcars/races</a>"
                </i>
            </div>
        </div>
    );
}